import React from "react";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import { blogPosts } from "../data/mock";
import { stripDiacritics } from "../lib/utils";
import usePageMetadata from "../hooks/usePageMetadata";

const BlogList = () => {
  usePageMetadata({
    title: "TOLSOL | Blog de consejos sobre toldos y p\u00e9rgolas",
    description:
      "Ideas, tendencias y gu\u00edas pr\u00e1cticas para sacar partido a tus terrazas y sistemas de protecci\u00f3n solar con TOLSOL.",
  });

  return (
    <main className="pt-32 pb-24 bg-[#F2F2F2] min-h-screen">
      <div className="container mx-auto px-4">
        <header className="max-w-3xl mx-auto text-center mb-16">
          <p className="uppercase tracking-[0.3em] text-sm text-[#0A192F]/60 mb-3">Blog Tolsol</p>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0A192F] mb-4">
            Inspiraci\u00f3n y consejos para sacar partido a tus espacios exteriores
          </h1>
          <p className="text-lg text-[#0A192F]/70">
            Descubre ideas para modernizar terrazas, optimizar la protecci\u00f3n solar y mantener tus instalaciones siempre a punto.
          </p>
        </header>

        <section className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow flex flex-col"
            >
              <div className="overflow-hidden" style={{ aspectRatio: "16 / 9" }}>
                <img src={post.image} alt={stripDiacritics(post.title)} className="w-full h-full object-cover" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-[#FFD700] mb-3">
                  <Calendar className="w-4 h-4" />
                  <span className="text-sm text-[#0A192F]/70">
                    {new Date(post.date).toLocaleDateString("es-ES")}
                  </span>
                </div>
                <h2 className="text-2xl font-bold text-[#0A192F] mb-3">{post.title}</h2>
                <p className="text-[#0A192F]/70 flex-1">{post.excerpt}</p>
                <Link
                  to={`/blog/${post.slug}`}
                  className="mt-6 inline-flex items-center gap-2 text-[#FFD700] font-semibold hover:gap-3 transition-all"
                >
                  Leer m\u00e1s
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </article>
          ))}
        </section>
      </div>
    </main>
  );
};

export default BlogList;
